import React, { useCallback } from 'react'
import {
    Dialog,
    DialogContent,
    Icon,
    Typography,
    DialogTitle,
    Table,
    TableRow,
    TableCell,
    TableBody,
    TableHead,
} from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/styles'
import { useDWPStates } from '../hooks/useDWPStates'
import { IconWithSubtext, SwitchMode } from '../components/DWPIcons'

const useStyles = makeStyles((theme) => ({
    title: {
        display: 'inline-block',
        fontSize: '2em',
        padding: 10,
        color: theme.palette.secondary.main,
        fontWeight: 500,
        marginRight: 20,
    },
    deleteIcon: {
        display: 'block',
        margin: 'auto',
        color: '#e02214',
    },
    checkedCircleIcon: {
        display: 'block',
        margin: 'auto',
        color: '#4CAF50',
    },
    tableContainer: {
        overflowX: 'auto',
    },
    headerCell: {
        minWidth: 140,
        whiteSpace: 'nowrap',
    },
}))

function ModalSubcontractors({ isOpen, onClose, subcontractors }) {
    const classes = useStyles()
    const { t } = useTranslation(['user'])
    const { findVDWPById, findIDWPById, findStateById } = useDWPStates()

    const executeOnClose = useCallback(() => {
        onClose(false)
    })

    return (
        <Dialog
            open={isOpen}
            onBackdropClick={executeOnClose}
            fullWidth
            maxWidth="lg">
            <DialogTitle>
                <Typography classes={{ root: classes.title }}>{t('subcontractorsList')}</Typography>
            </DialogTitle>
            <DialogContent>
                <div className={classes.tableContainer}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell align="center" className={classes.headerCell}>{t('companies')}</TableCell>
                                <TableCell align="center" className={classes.headerCell}>{t('Agency')}</TableCell>
                                <TableCell align="center" className={classes.headerCell}>{t('companyrecordstate')}</TableCell>
                                <TableCell align="center" className={classes.headerCell}>{t('PreliminaryVisit')}</TableCell>
                                <TableCell align="center" className={classes.headerCell}>{t('CoordinationMeeting')}</TableCell>
                                <TableCell align="center" className={classes.headerCell}>{t('dwpsendingmodecode')}</TableCell>
                                <TableCell align="center" className={classes.headerCell}>{t('dwpstatuscode')}</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {subcontractors && subcontractors.map(subcontractor => (
                                <TableRow key={subcontractor.companyId}>
                                    <TableCell align="center">{subcontractor.companyName}</TableCell>
                                    <TableCell align="center">{subcontractor.agencyName}</TableCell>
                                    <TableCell align="center">{(() => {
                                        let value = subcontractor.companyRecordState
                                        if (!value) return
                                        let currentState = findStateById(value)
                                        if (!currentState) return

                                        return (
                                            <IconWithSubtext
                                                icon={currentState.icon}
                                                label={currentState.label}
                                                color={currentState.color}
                                                status={currentState.id}
                                            />
                                        )
                                    })()}</TableCell>
                                    <TableCell align="center">{(() => {
                                        if (subcontractor.preliminaryVisit) return <Icon className={classes.checkedCircleIcon}>check_circle</Icon>
                                        else return <Icon className={classes.deleteIcon}>remove_circle</Icon>
                                    })()}</TableCell>
                                    <TableCell align="center">{(() => {
                                        if (subcontractor.coordinationMeeting) return <Icon className={classes.checkedCircleIcon}>check_circle</Icon>
                                        else return <Icon className={classes.deleteIcon}>remove_circle</Icon>
                                    })()}</TableCell>
                                    <TableCell align="center">{(() => {
                                        const currentVDWP = findVDWPById(subcontractor.dwpSendingModeCode)
                                        return (
                                            <SwitchMode
                                                label={currentVDWP.label}
                                                icon={currentVDWP.icon}
                                                color={currentVDWP.color}
                                            />)
                                    })()}</TableCell>
                                    <TableCell align="center">{(() => {
                                        const currentState = findIDWPById(subcontractor.dwpStatusCode)
                                        return (
                                            <IconWithSubtext
                                                icon={currentState.icon}
                                                label={currentState.label}
                                                color={currentState.color}
                                                id={currentState.id}
                                            />)
                                    })()}</TableCell>

                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </div>
            </DialogContent>
        </Dialog>
    )
}

export default ModalSubcontractors